<template>
    <div class="lsva-trailers-view">
        <div class="lsva-trailers-view__filters">
            <BaseInput
                :debounce="400"
                :placeholder="$t('searchPlaceholder')"
                block
                trim
                @input="nameSearchQuery = $event"
            >
                <template #icon>
                    <SearchIcon width="16" height="16" />
                </template>
            </BaseInput>
        </div>

        <div class="lsva-trailers-view__content">
            <LsvaTrailersTable :filter-name="nameSearchQuery" />
        </div>
    </div>
</template>

<script>
import BaseInput from '@/components/redesigned/BaseInput'
import LsvaTrailersTable from '@/components/lsva/LsvaTrailersTable'
import SearchIcon from '@/components/icons//SearchIcon'

export default {
    name: 'LsvaTrailersView',
    components: {
        BaseInput,
        LsvaTrailersTable,
        SearchIcon,
    },
    data() {
        return {
            nameSearchQuery: '',
        }
    },
}
</script>

<i18n>
{
    "en": {
        "searchPlaceholder": "Name"
    },
    "de": {
        "searchPlaceholder": "Name"
    },
    "fr": {
        "searchPlaceholder": "Nom"
    },
    "it": {
        "searchPlaceholder": "Nome"
    }
}
</i18n>

<style lang="scss" scoped>
.lsva-trailers-view {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;

    &__filters {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        padding: 1.5rem 1rem 0.5rem 2rem;
        background-color: $color-gray-lighter-new;
        border-bottom: $style-border;

        & > * {
            margin-right: 1rem;
            margin-bottom: 1rem;
        }

        .base-input,
        .multiselect {
            max-width: 200px;
        }
    }

    &__content {
        display: flex;
        overflow-y: auto;

        & > * {
            width: 100%;
        }
    }

    @include respond-to('for-small-mobile-only') {
        &__filters {
            padding: 1rem 1rem 0;

            & > * {
                &:not(.base-button) {
                    margin-right: 0;
                    max-width: 100%;
                    width: 100%;
                }
            }
        }
    }
}
</style>
